import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Share } from '@capacitor/share';
import { Message } from 'src/app/interfaces/message';
import { MessageService } from 'src/app/services/message.service';
import { ApiInit } from 'src/app/utils/api-init';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgIf, DatePipe } from '@angular/common';
import {
  IonContent,
  IonBackButton,
  IonHeader,
  IonToolbar,
  IonButtons,
} from '@ionic/angular/standalone';
import { DivClickDirective } from 'src/app/directives/div-click.directive';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-message',
  templateUrl: './message.page.html',
  standalone: true,
  imports: [
    NgIf,
    InlineSVGModule,
    DatePipe,
    IonContent,
    DivClickDirective,
    IonBackButton,
    IonHeader,
    IonToolbar,
    NgxSkeletonLoaderModule,
    IonButtons,
  ],
})
export class MessagePage implements OnInit {
  public loading: boolean = false;
  public message: Message;
  canShare: boolean = false;
  whitelabelName: string;
  whitelabelIcon: string;

  constructor(
    private currentApp: CurrentWhiteLabelApplication,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private app: CurrentWhiteLabelApplication,
    private apiInit: ApiInit
  ) {
    this.activatedRoute.params.subscribe(async (params) => {
      if (params.id) this.load(params.id);
    });

    this.whitelabelName = this.currentApp.getName();
    this.whitelabelIcon = this.currentApp.getIconThumbnails()?.small;

    Share.canShare().then(
      (result) => (this.canShare = result.value && !!app.getPwaDomain())
    );
  }

  async share() {
    Share.share({
      url: `https://${this.app.getPwaDomain()}/messages/${this.message.id}`,
    }).catch((e) => {
      // share cancelled
    });
  }

  ngOnInit() {}

  private load(id: number) {
    this.apiInit.watch(async () => {
      this.loading = true;
      this.message = await this.messageService.getMessage(id);
      this.loading = false;
    });
  }
}
